"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var browser_1 = require("@cian/config/browser");
var browser_2 = require("@cian/logger/browser");
var browser_3 = require("@cian/http-api/browser");
var setup_1 = require("./setup");
var vitals_1 = require("./vitals");
function init() {
    browser_1.init();
    browser_2.init();
    browser_3.init();
    vitals_1.initWebVitals();
    setup_1.setupWebpackPublicPath();
}
exports.init = init;
//# sourceMappingURL=interface.js.map